import { connect } from 'react-redux';
import { ChangePayScheduleContainer, PaymentScheduleEditButton } from '../styles';
import {
  setFundingInstruments,
  setPaymentInstrument,
} from '../../make-payment/step-two-amount/makePaymentStepTwoReducer';
import React from 'react';
import PropTypes from 'prop-types';

export const ChangePaySchedule = (props) => {
  const {
    dispatch,
    account,
    showEditPaymentSchedule,
    setShowEditPaymentMethod,
    setShowEditPaymentSchedule,
    initialState,
  } = props;
  return (
    <ChangePayScheduleContainer>
      Need to change your Payment Schedule?{' '}
      <PaymentScheduleEditButton
        aria-label={`Edit Pay Schedule`}
        onClick={() => {
          if (
            account?.electronicPaymentSource[0]?.customerPaymentProfileId ||
            account?.electronicPaymentSource[0]?.achBankAccountNumber
          ) {
            dispatch(setPaymentInstrument(account.electronicPaymentSource[0]));
            dispatch(setFundingInstruments([account?.electronicPaymentSource[0]]));
          }
          setShowEditPaymentMethod(initialState); // reset pay method clicked
          setShowEditPaymentSchedule({
            ...showEditPaymentSchedule,
            [account.id]: !showEditPaymentSchedule[account.id],
          });
        }}
      >
        Click Here
      </PaymentScheduleEditButton>
    </ChangePayScheduleContainer>
  );
};
ChangePaySchedule.propTypes = {
  dispatch: PropTypes.func,
  account: PropTypes.object,
  showEditPaymentSchedule: PropTypes.object,
  setShowEditPaymentMethod: PropTypes.func,
  initialState: PropTypes.object,
  setShowEditPaymentSchedule: PropTypes.func,
};
export default connect()(ChangePaySchedule);
